module.exports = {
  team: {
    id: process.env.VUE_APP_TEAM_ID ? process.env.VUE_APP_TEAM_ID : "",
  },
  api: {
    invokeUrl: process.env.VUE_APP_API_INVOKEURL,
    accessKey: "",
    secretKey: "",
    sessionToken: "",
    region: process.env.VUE_APP_API_REGION,
    apiKey: "undefined",
    defaultContentType: "application/json",
    defaultAcceptType: "application/json",
  },
  cognito: {
    Region: process.env.VUE_APP_COGNITO_REGION,
    UserPoolId: process.env.VUE_APP_COGNITO_USERPOOLID,
    ClientId: process.env.VUE_APP_COGNITO_CLIENTID,
    IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITYPOOLID,
  },
  locale: process.env.VUE_APP_LOCALE ? process.env.VUE_APP_LOCALE : "de",
  version: process.env.VUE_APP_VERSION,
  ie11polyfill: process.env.VUE_APP_IE11POLYFILL !== "false",
  switchVersion: {
    canSwitch: !!(
      process.env.VUE_APP_BACKOFFICE_URL_V1 &&
      process.env.VUE_APP_BACKOFFICE_URL_V2 &&
      process.env.VUE_APP_BACKOFFICE_VERSION &&
      process.env.VUE_APP_BACKOFFICE_VERSION_CAN_SWITCH === "true"
    ),
    current: process.env.VUE_APP_BACKOFFICE_VERSION ? process.env.VUE_APP_BACKOFFICE_VERSION : "v1",
    url: {
      v1: process.env.VUE_APP_BACKOFFICE_URL_V1,
      v2: process.env.VUE_APP_BACKOFFICE_URL_V2,
    },
  },
  pusher: {
    appId: process.env.VUE_APP_PUSHER_APP_ID,
    appKey: process.env.VUE_APP_PUSHER_APP_KEY,
    appSecret: process.env.VUE_APP_PUSHER_APP_SECRET,
    appCluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  },
};
